// import * as MessageActions from '../../common/messageBox/actions/actions';
import * as ActionTypes from './actionTypes';
import apiActionCreator from '../../common/service/api/actionCreator';
import {buildErrorMessage, buildSuccessMessage} from '../../common/util/errorUtils';

export const fecthCombosList = () => apiActionCreator({
  'endpoint': '/sets',
  'authenticated': true,
  'types': [
    ActionTypes.FETCHING_COMBOS_LIST,
    ActionTypes.FETCHED_COMBOS_LIST,
    [
      ActionTypes.FETCHED_COMBOS_LIST_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'GET',
});

export const cleanCombosList = () => ({
  'type': ActionTypes.CLEAN_COMBOS_LIST,
});

export const fecthComboAccessoriesList = (code) => apiActionCreator({
  'endpoint': `/sets/detail/${code}`,
  'authenticated': true,
  'types': [
    ActionTypes.FETCHING_COMBO_ACCESSORIES_LIST,
    ActionTypes.FETCHED_COMBO_ACCESSORIES_LIST,
    [
      ActionTypes.FETCHED_COMBO_ACCESSORIES_LIST_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'GET',
});

export const cleanComboAccessoriesList = () => ({
  'type': ActionTypes.CLEAN_COMBO_ACCESSORIES_LIST,
});

export const fecthComboDealersList = (code) => apiActionCreator({
  'endpoint': `/sets/dealer-combo/${code}`,
  'authenticated': true,
  'types': [
    ActionTypes.FETCHING_COMBO_DEALERS_LIST,
    ActionTypes.FETCHED_COMBO_DEALERS_LIST,
    [
      ActionTypes.FETCHED_COMBO_DEALERS_LIST_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'GET',
});

export const cleanComboDealersList = () => ({
  'type': ActionTypes.CLEAN_COMBO_DEALERS_LIST,
});

export const updateComboHeader = (data) => (dispatch) => {
  return dispatch(
    apiActionCreator({
      'endpoint': '/sets',
      'authenticated': true,
      'types': [
        ActionTypes.UPDATING_COMBO_HEADER,
        [
          () => {
            dispatch(fecthCombosList());
            return {
              'type': ActionTypes.UPDATED_COMBO_HEADER,
            };
          },
        ],
        [
          ActionTypes.UPDATED_COMBO_HEADER_FAILED,
          (error) => buildErrorMessage(error),
        ],
      ],
      'microservice': 'part',
      'contentType': 'application/json',
      'data': data,
      'method': 'PUT',
    }),
  );
};


export const uploadComboExcel = (data) => (dispatch) => {
  return dispatch(
    apiActionCreator({
      'endpoint': '/sets/combo-excel',
      'authenticated': true,
      'types': [
        ActionTypes.UPLOADING_COMBO_HEADER,
        [
          (response) => {
            dispatch(fecthCombosList());
            dispatch(buildSuccessMessage(response));
            return {
              'type': ActionTypes.UPLOADED_COMBO_HEADER,
            };
          },
        ],
        [
          ActionTypes.UPLOADED_COMBO_HEADER_FAILED,
          (error) => buildErrorMessage(error),
        ],
      ],
      'microservice': 'part',
      'contentType': 'application/json',
      'data': data,
      'method': 'PUT',
    }),
  );
};
